import { Component } from '@angular/core';
import { CreditsBalanceService } from '@core/services/credits-balance.service';
import { CreditsModalLauncherService } from '../../services/credits-modal-launcher.service';

@Component({
  selector: 'app-credits-balance-button',
  templateUrl: './credits-balance-button.component.html',
  styleUrls: ['./credits-balance-button.component.scss'],
})
export class CreditsBalanceButtonComponent {
  protected readonly summary$ = this.creditsBalanceService.summary$;
  /** Shown as soon as the user is eligible, before the balance report loads. */
  protected readonly visible$ = this.creditsBalanceService.eligible$;
  protected readonly v2$ = this.creditsBalanceService.v2Enabled$;

  constructor(
    private creditsBalanceService: CreditsBalanceService,
    private creditsModalLauncher: CreditsModalLauncherService
  ) {}

  open(): void {
    this.creditsModalLauncher.open('pill');
  }
}
